import { Component } from '@angular/core';

@Component({
  selector: 'app-email-confirmation-reminder',
  templateUrl: './email-confirmation-reminder.component.html',
  styleUrl: './email-confirmation-reminder.component.sass',
  standalone: false
})
export class EmailConfirmationReminderComponent {}
